// import { axiosPrivate } from "api/axios";
// import { AUTH_TOKEN } from "constants/AuthConstant";
// import store from "../store";

// const AccountService = {};

// AccountService.modifyAccount = function (data) {
//   return axiosPrivate({
//     url: "/users/manageAccount",
//     method: "put",
//     data: data,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };

// AccountService.changePassword = function (data) {
//   return axiosPrivate({
//     url: "/users/changePassword",
//     method: "put",
//     data: data,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };


// export default AccountService;


import { axiosPrivate } from "api/axios";
import { AUTH_TOKEN } from "constants/AuthConstant";
import Cookies from "js-cookie";
import store from "../store";

const AccountService = {};

AccountService.modifyAccount = function (data) {
  return axiosPrivate({
    url: "/users/manageAccount",
    method: "put",
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

AccountService.changePassword = function (data) {
  return axiosPrivate({
    url: "/users/changePassword",
    method: "put",
    data: data,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

export default AccountService;